let setEditedMessage = (state, { payload }) => {
    state.editedMessage = payload;
    document.getElementById('message').value = payload.message.text;
};
export default setEditedMessage;
